/**
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

/**
 * @class PostMessageSender
 *
 * Abstraction-layer for sending data through window.postMessage. Enables
 * message sending to a target window, where a PostMessageReceiver instance
 * handles parsing the data.
 */

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.689Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:base': []
})(this, function (m_module, _) {

var M = m_module.M;

"use strict";

  /**
   * Create a new PostMessageSender.
   *
   * @param {Object} target Target window for sending messages.
   * @param {String} origin Hostname expected on target window.
   */
  M.PostMessageSender = function(target, origin) {
    M.assert(M.SSL_BASE_URL);
    M.assert(typeof target === 'object');
    this.target = target;
    this.targetOrigin = origin || M.SSL_BASE_URL;
    this.actions = {};
    _.bindAll(this, 'send');
    return this;
  };

  /**
   * Sends a message to be interpreted by the target window's receiver.
   *
   * @param {String} action Name of the receiver function.
   * @param {...*} var_args Arguments applied to the receiver.
   *
   * @example
   * messageSender.send('alert', 'hello world', 'other', 'arguments', 0);
   */
  M.PostMessageSender.prototype.send = function() {
    // Create an object of the form { action: 'string', args: [...] }
    // which is stringified for older browsers and then sent to the target.
    var args = _.toArray(arguments);
    var message = {
      action: args.shift(),
      args: args
    };
    M.assert(_.isString(message.action));
    M.assert(_.isArray(message.args));
    this.target.postMessage(JSON.stringify(message), this.targetOrigin);
  };

return {
};

});
